import axiosInstance from "../services/axiosInstance";

export const createAttendance = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/attendance/create",
      payload
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const updateAttendance = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/attendance/update",
      payload
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const deleteAttendance = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/attendance/delete",
      payload
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getAttendanceDetail = async (companyId, idAttendance) => {
  try {
    const response = await axiosInstance.get(
      `console/attendance/detail?id=` +
        idAttendance +
        `&company_id=` +
        companyId
    );

    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Unknown error" };
  }
};

export const getHolidayReferences = async (companyId) => {
  try {
    const response = await axiosInstance.get(
      `console/holiday/references?company_id=` + companyId
    );

    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Unknown error" };
  }
};

export const importAttendance = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/attendance/import/validate",
      payload
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const SubmitImportAttendance = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/attendance/import/submit",
      payload
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getFingerprintMachines = async () => {
  try {
    const response = await axiosInstance.get(
      "console/attendance/import/fingerprint/machines"
    );

    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Unknown error" };
  }
};

export const importFingerprintAttendance = async (payload, config = {}) => {
  try {
    const response = await axiosInstance.post(
      "console/attendance/import/fingerprint/validate",
      payload,
      config
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const submitFingerprintImport = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/attendance/import/fingerprint/submit",
      payload
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};
